/*
 * @Description: file content
 * @Author: Lxc 1533761120@qq.com
 * @Date: 2024-05-11 17:01:05
 * @LastEditors: Xiaochun liu
 * @LastEditTime: 2024-11-20 17:50:59
 */
import { defineStore } from 'pinia'
import { getQaDailyLimit } from '../api'
import { useWorkspaceStore } from '@/store'

export interface AssistantLimitState {
  totalFreeTimes: number
  usedTimes: number
  showInsufficientEnergy: boolean
}

export const useAssistantLimitStore = defineStore('use-assistant-limit-store', {
  state: (): AssistantLimitState => ({
    /**
     * 每日总免费次数
     */
    totalFreeTimes: 0,
    /**
     * 每日已使用次数
     */
    usedTimes: 0,
    /**
     * 能量点不足弹窗
     */
    showInsufficientEnergy: false,
  }),
  actions: {
    updateAssistantLimit(times: AssistantLimitState) {
      this.totalFreeTimes = times.totalFreeTimes
      this.usedTimes = times.usedTimes
    },
    async getAssistantLimit() {
      const workspaceStore = useWorkspaceStore()
      const enterpriseId = workspaceStore.workspaceId as number
      // 更新助手的免费次数
      return getQaDailyLimit({ enterpriseId }).then((res) => {
        this.updateAssistantLimit(res)
      })
    },
    getRenewFreeTimes() {
      // 获取助手的免费次数
      const renewFreeTimes = this.totalFreeTimes - this.usedTimes
      return (renewFreeTimes < 1) ? 0 : renewFreeTimes
    },
    getInsufficientEnergyModel() {
      return this.showInsufficientEnergy
    },
    updateInsufficientEnergyModel(bool: boolean) {
      this.showInsufficientEnergy = bool
    },
  },
  getters: {
  },
})
